import React from 'react';

const PROJECTS_DATA = [
  {
    id: 'water',
    name: 'Smart Water Utility Data',
    tech: ['SCADA', 'Spark Streaming', 'Python', 'Databricks', 'SQL', 'Telemetry'],
    desc: 'Real-time telemetry data for flow sensors monitoring and risk indicators for a major UK utility.',
    location: 'London, UK',
    link: 'https://www.linkedin.com/in/jeremy-roy-52280269/',
    linkText: 'LinkedIn'
  },
  {
    id: 'geospatial',
    name: 'Geospatial Dam Levels Visualisation',
    tech: ['Python', 'React', 'GIS Analytics'],
    desc: 'Public facing dam level monitoring tool.',
    location: 'Cape Town, SA',
    link: 'https://damvisualiser.web.app/'
  },
  {
    id: 'Bussiness',
    name: 'Contractor Web Page',
    tech: ['React', 'Bussiness'],
    desc: 'Local contractor Bussiness',
    location: 'Cumbria, UK',
    link: 'https://edenconstructionservices.co.uk/'
  }
];

function Projects({ onLocateOnMap }) {
  return (
    <div className="projects-container">
      <div className="terminal-line" style={{ color: '#94a3b8', fontStyle: 'italic', marginBottom: '0.5rem' }}>
        ➜ cat projects.json
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
        {PROJECTS_DATA.map((proj) => (
          <div key={proj.id} id={`project-card-${proj.id}`} className="project-card">
            <div className="project-card-header">
              <h3>{proj.name}</h3>
              <div className="project-tech-list">
                {proj.tech.map((t, idx) => (
                  <span key={idx} className="project-tech-tag">{t}</span>
                ))}
              </div>
            </div>
            <p className="project-desc">{proj.desc}</p>
            <div className="project-footer">
              <span style={{ fontSize: '0.78rem', color: '#94a3b8', fontFamily: 'monospace' }}>
                📍 {proj.location}
              </span>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                {proj.link && (
                  <a
                    href={proj.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-locate"
                    style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>
                    {proj.linkText || 'Visit'}
                  </a>
                )}
                <button
                  className="btn-locate"
                  onClick={() => onLocateOnMap(proj.id)}
                  style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle></svg>
                  Locate on Map
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
export { PROJECTS_DATA };
